import React, { useId } from "react";

const GRADIENTS = {
  navy: ["#8D9AE3", "#2E3B9A"],
  gold: ["#FFE08A", "#F2B523"],
};

/** Servy's four-point sparkle: navy for the avatar, gold on the "Talk to Servy" button. */
const ServySparkle = ({ variant = "navy", size = 18, className }) => {
  const gradientId = `servy-sparkle-${variant}-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  const [from, to] = GRADIENTS[variant] || GRADIENTS.navy;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="4"
          y1="2"
          x2="20"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M12 1.5c.6 5.6 4.9 9.9 10.5 10.5-5.6.6-9.9 4.9-10.5 10.5-.6-5.6-4.9-9.9-10.5-10.5C7.1 11.4 11.4 7.1 12 1.5Z"
      />
    </svg>
  );
};

export default ServySparkle;
